module.exports = __webpack_public_path__ + "static/media/lpi03.ef4a1ce1.jpg";